import apiEndpoints from './apiEndpoints';
import { getRequest } from './index';

export const getDropoffLocations = ({ countryCode, postalCode, addressUid }) =>
  getRequest(apiEndpoints.shippings.dropoffLocations, {
    countryCode,
    postalCode,
    addressUid,
  });
